<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="$route.name === 'default'"
    id="rootElement"
    class="default-container theme"
    :class="[themeColorClass, {
      'theme-rtl theme-rtl-overlap': isRtl,
      'has-promotion-bar': usePromotionBar && customSetting.showPromotionHeader && isPromotionBarActive,
      'transparent': isTransparent
    }]"
  >
    <promotion-bar v-if="usePromotionBar && customSetting.showPromotionHeader" />
    <!--something wrong-->
    <div
      v-if="isSomethingWrong"
      class="full-center error-wrapper"
    >
      <figure
        ref="isSomethingWrong"
        class="error-wrapper-container"
      >
        <img
          :src="noPanoramasImage"
          alt="no panoramas"
        >
        <figcaption
          v-html="$t('somethingWrong')"
        />
      </figure>
    </div>
    <!--no liveTour, but has group-->
    <div
      v-else-if="!isExpired && isBuildingNotFound && property.objectId && property.buildings.length"
      class="full-center error-wrapper"
    >
      <figure
        ref="buildingNotInProperty"
        class="error-wrapper-container"
      >
        <img
          :src="noPanoramasImage"
          alt="no panoramas"
        >
        <figcaption
          v-html="$t('buildingNotInPropertyRedirect')"
        />
      </figure>
    </div>
    <!--not found property in url-->
    <div
      v-else-if="!isExpired && isPropertyNotFound"
      class="full-center error-wrapper"
    >
      <figure
        ref="buildingNotFound"
        class="error-wrapper-container"
      >
        <img
          :src="noPanoramasImage"
          alt="no panoramas"
        >
        <figcaption
          v-html="$t('buildingNotFound')"
        />
      </figure>
    </div>
    <!--User is expired or not found liveTour in url-->
    <div
      v-else-if="isExpired || isBuildingNotFound"
      class="full-center error-wrapper"
    >
      <figure
        ref="buildingNotFound"
        class="error-wrapper-container"
      >
        <img
          :src="noPanoramasImage"
          alt="no panoramas"
        >
        <figcaption
          v-html="$t(getNotFoundBuildingText)"
        />
      </figure>
    </div>
    <template v-else-if="isAppReady">
      <i-header />
      <i-main />
      <i-aside />
      <i-footer />
    </template>
    <loading />
    <i-alert
      position="top-right"
    />
  </div>
</template>

<script type="text/javascript">
import { mapActions, mapGetters } from 'vuex'
import { COLOR } from '~js/constants'
import { handleUserComesFromWhereEvent } from '~js/helpers'
import { isRtl } from '../../i18n/i18n-helper'
import IHeader from './IHeader'
import IMain from './IMain'
import IAside from './IAside'
import IFooter from './IFooter'
import IAlert from '@/components/IAlert'
import Loading from '@/components/common/Loading'
import PromotionBar from '@/components/common/PromotionBar'

export default {
  name: 'DefaultIndex',
  components: {
    IAlert,
    IHeader,
    IMain,
    IAside,
    IFooter,
    Loading,
    PromotionBar
  },

  beforeRouteEnter (to, from, next) {
    next(async vm => {
      const { buildingId } = to.params
      const propertyId = to.query.group
      handleUserComesFromWhereEvent(to, nextPath => {
        vm.$router.replace(nextPath)
      })
      if (propertyId) {
        await vm.fetchProperty({ propertyId, buildingId })
      } else {
        await vm.fetchBuilding(buildingId)
      }
    })
  },

  // select group's building will go here
  async beforeRouteUpdate (to, from, next) {
    if (to.params.buildingId !== from.params.buildingId ||
      to.query.group !== from.query.group) {
      const { buildingId } = to.params
      const propertyId = to.query.group
      if (propertyId && this.property.objectId !== propertyId) {
        await this.fetchProperty({ propertyId, buildingId })
      } else {
        let targetBuildingId = buildingId
        const propertyBuildings = this.property.buildings
        if (!buildingId && propertyBuildings.length) {
          targetBuildingId = propertyBuildings[0].objectId
        }
        await this.fetchBuilding(targetBuildingId)
      }
    }
    next()
  },

  data () {
    return {
      isRtl: isRtl(),
      usePromotionBar: process.env.USE_PROMOTION_BAR
    }
  },

  computed: {
    ...mapGetters([
      'customSetting',
      'isAppReady',
      'isBuildingNotFound',
      'isPromotionBarActive',
      'isPropertyNotFound',
      'isSomethingWrong',
      'isExpired',
      'krpanoEl',
      'panoramas',
      'property',
      'themeColor',
      'headquarter'
    ]),

    noPanoramasImage () {
      return require('../../assets/images/trash-can.svg')
    },

    themeColorClass () {
      const defaultTheme = 'theme-pink'

      if (!process.env.USE_THEME_COLOR) {
        return defaultTheme
      }

      switch (this.themeColor) {
        case COLOR.ETWARM_THEME:
          return 'theme-etwarm-red'
        case 'black':
          return 'theme-black'
        case 'blue':
          return 'theme-blue'
        case 'green':
          return 'theme-green'
        case 'orange':
          return 'theme-orange'
        case 'yellow':
          return 'theme-yellow'
        case 'pink':
          return 'theme-pink'
        default:
          return defaultTheme
      }
    },

    isTransparent () {
      return this.$route.query.background === 'transparent'
    },

    getNotFoundBuildingText () {
      return 'buildingNotFound'
    }
  },

  methods: {
    ...mapActions([
      'fetchProperty',
      'fetchBuilding',
      'setPanorama'
    ])
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

.default-container {
  position: relative
  height: 100%
  background-color: $black

  &.transparent {
    background-color: transparent
  }

  &.has-promotion-bar {
    height: "calc(100% - %s)" % $promotion-bar-height
    margin-top: $promotion-bar-height
  }
}

.livetour-intro {
  img {
    border-radius: 50%
    width: 100px
    height: 100px
  }
}
</style>
